import { NB_LANG } from 'constants/language';

export const sortWithUnicodeBy = (arr, field, locale = NB_LANG) => {
  const collator = new Intl.Collator(locale, {
    sensitivity: 'accent',
    caseFirst: 'upper',
  });
  return arr.sort((a, b) => collator.compare(a[field], b[field]));
};
